import { render } from "./DataQualityScorecardTable.vue?vue&type=template&id=1bb8614e&scoped=true"
import script from "./DataQualityScorecardTable.vue?vue&type=script&lang=js"
export * from "./DataQualityScorecardTable.vue?vue&type=script&lang=js"

import "./DataQualityScorecardTable.vue?vue&type=style&index=0&id=1bb8614e&scoped=true&lang=css"
import "./DataQualityScorecardTable.vue?vue&type=style&index=1&id=1bb8614e&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb8614e"]])

export default __exports__